import axios from 'axios'

export default {
  async getClientIp() {
    try {
      const response = await axios.get('https://api.ipify.org?format=json')
      return response.data.ip
    } catch (error) {
      console.error('Erro ao obter IP:', error)
      return ''
    }
  },
  async PageViewEvent(userData) {
    try {
      const [em, ph, country, clientIp] = await Promise.all([
        this.hashEmail(localStorage.getItem('userEmail')),
        this.hashPhone(localStorage.getItem('userPhone')),
        this.hashCountry(navigator.language.split('-')[1] || 'BR'),
        this.getClientIp(),
      ])
      const eventData = [
        {
          event_name: 'PageView',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          user_data: {
            client_ip_address: clientIp,
            client_user_agent: navigator.userAgent,
            em,
            ph,
            external_id: localStorage.getItem('userId'),
            fbc: this.getFbc(),
            fbp: this.getFbp(),
            country,
          },
          action_source: 'website',
          custom_data: {
            content_name: document.title,
            content_category: 'page_view',
            content_ids: [window.location.pathname],
            value: 0,
            currency: userData.currency,
            device_model: navigator.platform,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            browser_language: navigator.language,
          },
        },
      ]

      return this.sendEvent(eventData)
    } catch (error) {
      console.error('Erro no PageViewEvent:', error)
      throw error
    }
  },

  async InitiateCheckoutEvent(userData) {
    try {
      const [em, ph, country, clientIp] = await Promise.all([
        this.hashEmail(userData.email),
        this.hashPhone(userData.phone),
        this.hashCountry(navigator.language.split('-')[1] || 'BR'),
        this.getClientIp(),
      ])

      const eventData = [
        {
          event_name: 'InitiateCheckout',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          user_data: {
            client_ip_address: clientIp,
            client_user_agent: navigator.userAgent,
            em,
            ph,
            external_id: localStorage.getItem('userId'),
            fbc: this.getFbc(),
            fbp: this.getFbp(),
            country,
          },
          action_source: 'website',
          custom_data: {
            content_name: 'Checkout',
            content_category: 'checkout',
            plan_name: userData.plan_name,
            value: userData.plan_value,
            currency: userData.currency,
            device_model: navigator.platform,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            browser_language: navigator.language,
          },
        },
      ]

      return this.sendEvent(eventData)
    } catch (error) {
      console.error('Erro no InitiateCheckout:', error)
      throw error
    }
  },

  async PurchaseEvent(userData) {
    try {
      const [em, ph, country, clientIp] = await Promise.all([
        this.hashEmail(userData.email),
        this.hashPhone(userData.phone),
        this.hashCountry(navigator.language.split('-')[1] || 'BR'),
        this.getClientIp(),
      ])

      const eventData = [
        {
          event_name: 'Purchase',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          user_data: {
            client_ip_address: clientIp,
            client_user_agent: navigator.userAgent,
            em,
            ph,
            external_id: localStorage.getItem('userId'),
            fbc: this.getFbc(),
            fbp: this.getFbp(),
            country,
          },
          action_source: 'website',
          custom_data: {
            content_name: 'Purchase',
            content_category: 'purchase',
            plan_name: userData.plan_name,
            currency: userData.currency || 'BRL',
            value: userData.plan_value || 0,
            plan_value: userData.plan_value,
          },
        },
      ]

      return this.sendEvent(eventData)
    } catch (error) {
      console.error('Erro no Purchase:', error)
      throw error
    }
  },

  async LeadEvent(userData) {
    try {
      const [em, ph, country, clientIp] = await Promise.all([
        this.hashEmail(userData.email),
        this.hashPhone(userData.phone),
        this.hashCountry(navigator.language.split('-')[1] || 'BR'),
        this.getClientIp(),
      ])

      const eventData = [
        {
          event_name: 'Lead',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          user_data: {
            client_ip_address: clientIp,
            client_user_agent: navigator.userAgent,
            em,
            ph,
            external_id: localStorage.getItem('userId'),
            fbc: this.getFbc(),
            fbp: this.getFbp(),
            country,
          },
          action_source: 'website',
          custom_data: {
            content_name: 'Lead',
            content_category: 'LeadEvent',
            plan_name: userData.plan_name,
            value: userData.plan_value,
            currency: userData.currency,
            device_model: navigator.platform,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            browser_language: navigator.language,
          },
        },
      ]

      return this.sendEvent(eventData)
    } catch (error) {
      console.error('Erro no Lead:', error)
      throw error
    }
  },

  sendEvent(eventData) {
    return axios
      .post('https://api-v2.pandavideo.com/marketing/facebook', eventData, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          return response.data
        }
        throw new Error('Erro ao enviar evento para o Facebook')
      })
      .catch((error) => {
        console.error('Erro no Facebook Conversion API:', error)
        throw error
      })
  },

  async hashEmail(email) {
    if (!email) return ''
    try {
      const hash = await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(email.toLowerCase())
      )
      return Array.from(new Uint8Array(hash))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
    } catch (error) {
      console.error('Erro ao hashear email:', error)
      return ''
    }
  },

  hashPhone(phone) {
    if (!phone) return ''
    const digits = phone.replace(/\D/g, '')
    return crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(digits))
      .then((hash) =>
        Array.from(new Uint8Array(hash))
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('')
      )
  },

  hashCountry(country) {
    if (!country) return ''
    return crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(country.toUpperCase()))
      .then((hash) =>
        Array.from(new Uint8Array(hash))
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('')
      )
  },

  getFbc() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('fbclid') || ''
  },

  getFbp() {
    const fbCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('_fbp='))
    return fbCookie ? fbCookie.split('=')[1] : ''
  },
}
